const summerJacketsData = [
  {
    id: 501,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800",
    title: "Black Genesis Summer Jacket",
    price: 1499,
    description: "Lightweight summer jacket designed for comfort and style."
  },
  {
    id: 502,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800",
    title: "Brown Breeze Summer Jacket",
    price: 1299,
    description: "Breathable jacket perfect for workouts and casual wear."
  },
  {
    id: 503,
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800",
    title: "Grey Summer Jacket",
    price: 1299,
    description: "Modern grey jacket with premium fabric."
  },
  {
    id: 504,
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=800",
    title: "Red Summer Jacket",
    price: 1499,
    description: "Bold and stylish red jacket for active lifestyles."
  },
  {
    id: 505,
    image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800",
    title: "Navy Hoodie",
    price: 1499,
    description: "Comfortable navy hoodie with premium finish."
  },
  {
    id: 506,
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800",
    title: "Combo Offer Jacket Pack",
    price: 2499,
    description: "Value pack containing multiple premium jackets."
  },
  {
    id: 507,
    image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=800",
    title: "Monsoon Rain Jacket",
    price: 1549,
    description: "Water-resistant rain jacket for outdoor activities."
  },
  {
    id: 508,
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=800",
    title: "Hybrid Blue Jacket",
    price: 1499,
    description: "Hybrid training jacket with superior comfort."
  }
];

export default summerJacketsData;